import * as PIXI from 'pixi.js'
import MyApplication from '../../../pixi/MyApplication'
import AssetsManager from '../../../pixi/AssetsManager'

/**
 * BtnViewクラス
 */
class BtnView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------
  //速度
  private _speed: number

  // ---------------------------------------------------------------------------------------------------------
  // --	BtnView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor(
    label: string,
    rect: PIXI.Rectangle = new PIXI.Rectangle(0, 0, 250, 60),
    textSize: number = 32,
    textColor: number = 0xffff00,
    baseColor: number = 0x000000
  ) {
    super()

    //ベース
    const base: PIXI.Graphics = new PIXI.Graphics()
    base.beginFill(baseColor)
    base.drawRect(-rect.width / 2, -rect.height / 2, rect.width, rect.height)
    base.endFill()
    this.addChild(base)

    //ラベル配置
    const labelText: PIXI.Text = new PIXI.Text(label, {
      fontFamily: 'BIT',
      fontSize: textSize,
      fill: textColor,
      align: 'center',
    })
    labelText.anchor.set(0.5, 0.5)
    this.addChild(labelText)

    //カーソル
    this.cursor = 'pointer'
  }

  activate(bool: boolean) {
    this.interactive = bool
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default BtnView
